
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { defineComponent, computed, ref, onBeforeMount } from 'vue';
import { IAuthActions, IAuthGetters, IAuthState } from '../login/types';
const { useState, useGetters, useActions, useMutations } =
  createNamespacedHelpers<IAuthState, IAuthGetters, IAuthActions>('auth');
import BaseIcon from '@/components/BaseIcon.vue';
import Tabs from '@/modules/dashboard/components/DashboardTabs.vue';
import { isAllowScreen } from '@/common/helpers/ModuleHelpers';
import router from '@/router';
import { mapActions } from 'vuex';

export default defineComponent({
  name: 'Dashboard',

  components: {
    Tabs,
    BaseIcon,
  },

  data() {
    return {
      filters: {
        maxDate: '',
        minDate: '',
        date: '',
      },
    };
  },

  computed: {
    currentFormattedDate() {
      let date = '';
      const now = new Date();
      if (this.getFilteredDateYYYYMM) {
        date = new Date(
          `${this.getFilteredDateYYYYMM}-${now.getDate()}`
        ).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        });
      } else {
        date = new Date().toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        });
      }

      return date;
    },
  },

  watch: {
    getFilteredDateYYYYMM: {
      handler(newValue, oldValue) {
        if (newValue === oldValue) return;
        this.sessionUpdate(this.billingUnit.billingUnitCode);
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('auth', ['setFilteredDateYYYYMM']),
    maxDateValid() {
      const currentDate = new Date();
      const yyyy = currentDate.getFullYear().toString();
      const mm =
        currentDate.getMonth() + 1 < 10
          ? `0${(currentDate.getMonth() + 1).toString()}`
          : (currentDate.getMonth() + 1).toString();
      const formattedDate = `${yyyy}-${mm}`;
      return formattedDate;
    },
    minDateValid() {
      const currentDate = new Date();
      const yyyy = currentDate.getFullYear().toString();
      const mm =
        currentDate.getMonth() < 10
          ? `0${currentDate.getMonth().toString()}`
          : currentDate.getMonth().toString();
      const formattedDate = `${yyyy}-${mm}`;
      return formattedDate;
    },
    handlerDate(event) {
      this.setFilteredDateYYYYMM(event.target.value);
      this.filters.date = this.getFilteredDateYYYYMM;
    },
  },

  created() {
    const maxDate = this.maxDateValid();
    this.filters.maxDate = maxDate;
    const minDate = this.minDateValid();
    this.filters.minDate = minDate;
    if (this.sessionUser.filteredDateYYYYMM) {
      this.filters.date = this.sessionUser.filteredDateYYYYMM;
    } else {
      this.setFilteredDateYYYYMM(maxDate);
      this.filters.date = maxDate;
    }
  },

  setup() {
    const { billingUnit, nextBillingUnitCode } = useState([
      'billingUnit',
      'nextBillingUnitCode',
    ]);
    const { userBillingUnits, sessionUser, getFilteredDateYYYYMM } = useGetters(
      ['userBillingUnits', 'sessionUser', 'getFilteredDateYYYYMM']
    );

    const nextBilling = computed(() =>
      userBillingUnits.value.find(
        (unit) => unit.billingUnitCode === nextBillingUnitCode.value
      )
    );

    const { SET_ACCESS_TYPE } = useMutations(['SET_ACCESS_TYPE']);

    const { sessionUpdate } = useActions(['sessionUpdate']);

    let show = ref(false);

    onBeforeMount(() => SET_ACCESS_TYPE('panel'));
    const alterBillingUnit = async (
      billingUnitCode = nextBillingUnitCode.value
    ) => {
      if (
        sessionUser.value.billingUnitAccess ===
          sessionUser.value.billingUnits[
            sessionUser.value.billingUnits.length - 1
          ].billingUnitCode &&
        isAllowScreen('isAllowedBrandManagementBillingScreen')
      ) {
        router.push({ name: 'DashboardBrandManagement' });
      } else {
        show.value = true;
        setTimeout(async () => {
          await sessionUpdate(billingUnitCode);
          show.value = false;
        }, 3000);
      }
    };
    computed(() => billingUnit.value.billingUnitCode);
    return {
      show,
      billingUnit,
      userBillingUnits,
      getFilteredDateYYYYMM,
      alterBillingUnit,
      nextBilling,
      sessionUser,
      sessionUpdate,
    };
  },
});
